var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tile", { staticClass: "branches", attrs: { link: "branches" } }, [
    _c(
      "div",
      {
        staticClass: "branches__header",
        attrs: { slot: "tileHeader" },
        slot: "tileHeader",
      },
      [
        _c("tile-title", { attrs: { icon: "sitemap" } }, [
          _vm._v("Филиалы и представительства"),
        ]),
        _vm._v(" "),
        _c(
          "app-switcher",
          {
            attrs: {
              leftClickHandler: _vm.changeType,
              rightClickHandler: _vm.changeType,
            },
          },
          [
            _c("span", { attrs: { slot: "leftValue" }, slot: "leftValue" }, [
              _vm._v("ФНС"),
            ]),
            _vm._v(" "),
            _c("span", { attrs: { slot: "rightValue" }, slot: "rightValue" }, [
              _vm._v("ГМЦ Росстата"),
            ]),
          ]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "brnaches__content",
        attrs: { slot: "tileContent" },
        slot: "tileContent",
      },
      [
        _c(
          "app-transition",
          {
            attrs: {
              showLeftIf: _vm.currentType === "fns",
              showRightIf: _vm.currentType === "rosstat",
            },
          },
          [
            _c("branches-table", {
              attrs: {
                slot: "left",
                type: "fns",
                list: _vm.fnsList.slice(0, 6),
              },
              slot: "left",
            }),
            _vm._v(" "),
            _c("branches-table", {
              attrs: {
                slot: "right",
                type: "rosstat",
                list: _vm.rosstatList.slice(0, 6),
              },
              slot: "right",
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("branches-modal", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isModal,
              expression: "isModal",
            },
          ],
          ref: "modalRef",
          attrs: {
            list: _vm.modalList,
            type: _vm.currentType,
            title: _vm.title,
            printStyle: _vm.printStyle,
          },
          on: { close: _vm.closeModal },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "branches__footer",
        class: { "flex-end": _vm.totalCount <= 6 },
        attrs: { slot: "tileFooter" },
        slot: "tileFooter",
      },
      [
        _vm.totalCount > 6
          ? _c(
              "tile-button",
              {
                nativeOn: {
                  click: function ($event) {
                    return _vm.openModal.apply(null, arguments)
                  },
                },
              },
              [
                _vm._v("Филиалы и представительства "),
                _vm.auth
                  ? _c("span", [_vm._v("(" + _vm._s(_vm.totalCount) + ")")])
                  : _vm._e(),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("tile-print-pdf", {
          attrs: {
            filename: "Branches",
            html: _vm.htmlContent,
            printStyle: _vm.printStyle,
            title: _vm.title,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }